<template>
  <b-container>
    <b-col class="text-left">
      <router-link :to="{ name: ($route.query.mode ==='default-address'? 'DefaultAddresses':'Address') }">
        <b-button pill variant="purple" class="ml-1 mb-1"
        > بازگشت به صفحه آدرس ها
        </b-button
        >
      </router-link>
    </b-col>
    <form @submit.prevent="onSubmit">

      <b-row>
        <form-group class="col-lg-3" v-if="addressName" :validations="$v.form.name">
          <div slot-scope="{ errors, invalid }">
            <label>نام آدرس</label>

            <input v-model="form.name" type="text" class="form-control" :disabled="form.sendForMe">

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group class="form-group col-lg-9 text-right  " :validations="$v.form.address">
          <div slot-scope="{ errors, invalid }">
            <label for="inputAddress">آدرس</label>
            <input v-model="form.address" type="text" class="form-control address-text" id="inputAddress">
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>
      </b-row>


      <div class="row pt-3">

        <form-group class="form-group col-lg-12 text-right  " :validations="$v.form.description">
          <div slot-scope="{ errors, invalid }">
            <label for="inputAddress">توضیحات</label>
            <input v-model="form.description" type="text" class="form-control address-text" id="inputDescription">
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <div class="col-lg-4">
          <form-group :validations="$v.form.postal_code">
            <div slot-scope="{ errors, invalid }">
              <label>کدپستی(غیرالزامی)</label>
              <input v-model="form.postal_code" type="text" class="form-control text-left">
              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </div>

        <form-group class="col-lg-3" :validations="$v.form.tax" v-if="defaultAddressStatus">
          <div slot-scope="{ errors, invalid }">
            <label>مالیات بر روی آدرس</label>

            <input v-model="form.tax" type="text" class="form-control">

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

      </div>

      <div class="row pt-3">


        <form-group class="col-lg-6 text-right"
                    v-if="!findAttributeOnSiteInfo('default_province') && !findAttributeOnSiteInfo('default_city')"
                    :validations="$v.form.province">
          <div slot-scope="{ errors, invalid }">

            <label for="inputAddress" style="margin-right: 1rem">استان</label>
            <b-form-input v-model="form.province" debounce="400" autocomplete="off" @update="provinceSearch"
                          list="provinces-list"></b-form-input>

            <datalist id="provinces-list">
              <option v-for="province in provinces" :key="province.id" :value="province.name">{{
                  province.name
                }}
              </option>
            </datalist>

            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <form-group
            v-if="isProvinceFill && !findAttributeOnSiteInfo('default_city' ) || !findAttributeOnSiteInfo('default_city' ) && findAttributeOnSiteInfo('default_province').length > 0 "
            class="col-lg-6 text-right"
            :validations="$v.form.city">
          <div slot-scope="{ errors, invalid }">
            <label for="inputAddress" style="margin-right: 1rem">شهر</label>
            <b-form-input v-model="form.city" debounce="400" @update="citySearch" autocomplete="off"
                          list="cities-list"></b-form-input>

            <datalist id="cities-list">
              <option v-for="city in cities">{{ city.name }}</option>
            </datalist>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>
      </div>

      <b-btn variant="purple" pill type="submit" class=" mt-2 w-100">
        ثبت
      </b-btn>

    </form>

  </b-container>
</template>

<script>
import router from "@/router";
import {mapGetters, mapActions} from "vuex";
import {required, minLength, maxLength, numeric, requiredIf} from "vuelidate/lib/validators";
import FormGroup from "../../validator/FormGroup";
import FormErrorsManager from '../../validator/FormErrorsManager.vue'
import {findObjects} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";


export default {
  name: "AddressForm",
  components: {FormGroup, FormErrorsManager},
  props: {
    submitFunction: {},
    title: {},
    addressName: {
      default: true
    },
  },
  data() {
    return {
      form: {
        id: '',
        name: '',
        description: '',
        address: '',
        province: '',
        city: '',
        postal_code: '',
        plate: '',
        default_address: 0,
        tax: null,
      },
    }
  },
  validations: {
    form: {
      name: {
        required: requiredIf(function (nestedModel) {
          return this.addressName
        })
      },
      description: {},
      address: {required},
      province: {required},
      city: {required},
      postal_code: {minLength: minLength(10), maxLength: maxLength(10)},
      tax: {minLength: minLength(0), maxLength: maxLength(100)},
    }
  },
  computed: {
    ...mapGetters({
      "provinces": "Province/getProvinces",
      "cities": "City/getCities"
    }),
    isProvinceFill() {
      return findObjects(this.$store.getters['Province/getProvinces'], this.form.province) != null
    },
    defaultAddressStatus() {
      return router.currentRoute.query.mode === 'default-address'
    }
  },
  methods: {
    ...mapActions({
      'provinceSearch': "Province/search"
    }),
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {

        try {
          const form = this.form

          let province = 0
          let city = 0

          if (this.findAttributeOnSiteInfo('default_city')) {
            const site_info_city = this.findAttributeOnSiteInfo('default_city')[0];
            province = site_info_city.province.id;
            city = site_info_city.id;
          } else {
            province = findObjects(this.$store.getters['Province/getProvinces'], form.province).id;
            city = findObjects(this.$store.getters['City/getCities'], form.city).id;
          }

          let data = {...form, province_id: province, city_id: city}

          if (!this.addressName) {
            data['name'] = this.form.address.slice(0, 25)
          }


          this.submitFunction(data);
        } catch (e) {
          toast('شهر یا استان انتخاب شده یافت نشد', 'شهر یا استان انتخاب شده یافت نشد', 'danger')
        }


      }
    },
    citySearch(words) {
      let province = findObjects(this.$store.getters['Province/getProvinces'], this.form.province).id;
      this.$store.dispatch('City/search', {words, province});
    },
  },
  async mounted() {
    const addressId = router.currentRoute.params.id

    if (this.findAttributeOnSiteInfo('default_province').length > 0) {
      const province = this.findAttributeOnSiteInfo('default_province')[0];
      this.form.province = province.name
      await this.provinceSearch(province.name)
    }

    if (this.findAttributeOnSiteInfo('default_city').length > 0) {
      const site_info_city = this.findAttributeOnSiteInfo('default_city')[0];
      this.form.province = site_info_city.province.id
      this.form.city = site_info_city.id
    }


    if (addressId !== undefined && router.currentRoute.query.mode !== 'default-address') {
      this.form.id = addressId;
      const form = this.form
      this.$store.dispatch('Address/getAddress', form).then(async res => {
        const address = res.data.data
        form.name = address.name

        form.id = address.id
        form.address = address.address
        form.province = address.province.name
        form.city = address.city.name
        form.postal_code = address.postal_code
        form.apartmentId = address.apartmentId
        form.plate = address.plate
        form.tax = address.tax

        this.$store.dispatch('Province/search', form.province).then(res => {
          this.$store.dispatch('City/search', {words: form.city, province: address.province.id});
        })

      }).catch(err => {
        console.log(err)
        router.push({name: 'Address'})
      })
    }
    if (addressId !== undefined && this.defaultAddressStatus) {
      this.form.id = addressId;
      const form = this.form
      this.$store.dispatch('Address/getDefaultAddress', form).then(async res => {
        const address = res.data.data


        form.name = address.name
        form.last_name = address.last_name
        form.cellphone = address.cellphone

        form.id = address.id
        form.address = address.address
        form.province = address.province.name
        form.city = address.city.name
        form.postal_code = address.postal_code
        form.apartmentId = address.apartmentId
        form.plate = address.plate
        form.tax = address.tax

        this.$store.dispatch('Province/search', form.province).then(res => {
          this.$store.dispatch('City/search', {words: form.city, province: address.province.id});
        })

      }).catch(err => {
        console.log(err)
        router.push({name: 'Address'})
      })

    }
  }
};

</script>

<style scoped>
.address-text {
  height: 5rem;
}

.color-btn {
  background-color: #bf61ee;
  border: none;
  color: white;
}
</style>